// extracted by mini-css-extract-plugin
export default {"positiveInfo":"#a9ebc5","negativeInfo":"#fed7d7","neutralInfo":"#f4da6f"};